export function section03() {
    // window.addEventListener("DOMContentLoaded", (event) => {
    const updateInitialContentStyles = (x) => {
        let el = document.querySelectorAll(
            `.slice-3 #website-content #content-0${x} *`
        )
        el.forEach((e) => {
            e.style.opacity = "0"
            e.style.transform = "translateY(20px)"
            e.style.position = "absolute"
        })
    }

    // Create slider inside laptop
    const laptopSwiper = new Swiper(".laptop-swiper", {
        slidesPerView: 2,
        centeredSlides: true,
        spaceBetween: 200,
        grabCursor: true,
        autoplay: false,
        breakpoints:
        {
            900: {
                navigation: {
                    nextEl: '.custom-slider-arrows .prev-1',
                    prevEl: '.custom-slider-arrows .next-1',
                },
            }
        },
        on: {
            init: function () {
                updateInitialContentStyles(2)
            },
        },
    })

    // Change laptop content on slide change
    const changeLaptopContent = (x) => {
        let offScreenEl = `.slice-3 #website-content #content-0${(x % 2) + 1} *`
        let onScreenEl = `.slice-3 #website-content #content-0${x} *`

        gsap.timeline()
            .to(offScreenEl, {
                y: "-20px",
                opacity: "0",
                duration: 0.35,
                ease: "Power1.easeOut",
                stagger: 0.15,
                onComplete: function () {
                    document.querySelectorAll(offScreenEl).forEach((e) => {
                        e.style.position = "absolute"
                    })
                    document.querySelectorAll(onScreenEl).forEach((e) => {
                        e.style.position = "relative"
                    })
                },
            })
            .to(
                onScreenEl,
                {
                    y: "0",
                    opacity: "1",
                    duration: 0.35,
                    ease: "Power1.easeOut",
                    stagger: 0.15,
                },
                ">"
            )
            .to(
                offScreenEl,
                {
                    y: "20px",
                    duration: 0.05,
                    ease: "Power1.easeOut",
                },
                "<"
            )

        if (x == 1) {
            mainWebsiteScroll02.pause()
            mainWebsiteScroll02.seek(0)
            mainWebsiteScroll01.restart()
        } else {
            mainWebsiteScroll01.pause()
            mainWebsiteScroll01.seek(0)
            mainWebsiteScroll02.restart()
        }
    }

    let activeScreenshot01 = document.querySelector(
        ".section.slice-3 .swiper-slide:nth-child(1) img"
    )
    let mainWebsiteScroll01 = gsap
        .timeline({
            repeat: -1,
            repeatDelay: 1,
            yoyo: false,
            defaults: { duration: 1.5, ease: "expo.inOut" },
        })
        .to(
            activeScreenshot01,
            {
                y: "-23%",
            },
            "0.5"
        )
        .to(
            activeScreenshot01,
            {
                y: "-48%",
            },
            ">+0.35"
        )
        .to(
            activeScreenshot01,
            {
                y: "-70%",
            },
            ">+0.25"
        )
        .to(
            activeScreenshot01,
            {
                y: "0",
                duration: 1.8,
                ease: "back.out(0.55)",
            },
            ">+1"
        )

    let activeScreenshot02 = document.querySelector(
        ".section.slice-3 .swiper-slide:nth-child(2) img"
    )
    let mainWebsiteScroll02 = gsap
        .timeline({
            repeat: -1,
            repeatDelay: 1,
            yoyo: false,
            defaults: { duration: 1.5, ease: "expo.inOut" },
        })
        .to(
            activeScreenshot02,
            {
                y: "-23%",
            },
            "0.5"
        )
        .to(
            activeScreenshot02,
            {
                y: "-48%",
            },
            ">+0.35"
        )
        .to(
            activeScreenshot02,
            {
                y: "-70%",
            },
            ">+0.25"
        )
        .to(
            activeScreenshot02,
            {
                y: "0",
                duration: 1.8,
                ease: "back.out(0.55)",
            },
            ">+1"
        )
        .pause()

    laptopSwiper.on("slideChange", (event) => {
        let sliderCounter = laptopSwiper.realIndex + 1
        changeLaptopContent(sliderCounter)
        gsap.to(".section.slice-3 .swiper-slide img", {
            y: "0%",
        })
    })
    // })
}
